setTimeout(limitMysteryProductCheckout(), 200);
function limitMysteryProductCheckout() {
  //console.log("-----check mystery lens quantity------")
  var currentcart = null;

  if (window.priceTier.cart != null){
    currentcart = window.priceTier.cart.items;

    if (  currentcart.length > 0) {
    
      var countMysteryLens = 0;
      var countCosplayMysteryLens = 0;
      var diff = 0;
      var newQty = 0;
      
      for (var i = 0; i < currentcart.length; i++) {
         //remove extra instabook line item/qty
    	  var keyId = window.priceTier.cart.items[i].key;
    	  var itemQty = window.priceTier.cart.items[i].quantity;
          var productId = window.priceTier.cart.items[i].product_id; 
      	  var itemLine = i + 1;
       
       
           if(productId == '6671821275194'){

               countMysteryLens = countMysteryLens + itemQty;
                //console.log("countMysteryLens right now", countMysteryLens);  
               if(countMysteryLens > 5){
                 
                
                 var diff = countMysteryLens - 5;
               
                 if(itemQty > diff){
                 newQty = itemQty - diff
                 }else{
                 newQty = 0;
                   
                 }
                 
                // console.log("different to be removed", diff);
                // console.log("on which keyID?", keyId);
                // console.log("newQty", newQty);
                
                 updateCartMystery(keyId, newQty);           
              
               }

           }else if(productId == '6822005473338'){

               countCosplayMysteryLens = countCosplayMysteryLens + itemQty;
               // console.log("countCosplayMysteryLens right now", countCosplayMysteryLens);  
               if(countCosplayMysteryLens > 5){
                 
                
                 var diff = countCosplayMysteryLens - 5;
               
                 if(itemQty > diff){
                 newQty = itemQty - diff
                 }else{
                 newQty = 0;
                   
                 }
                 
                 //console.log("different to be removed", diff);
                 //console.log("on which keyID?", keyId);
                 //console.log("newQty", newQty);
                
                 updateCartMystery(keyId, newQty);
         
               }
 
           }
        }

        console.log("countMysteryLens", countMysteryLens);
 
      }
    }
}


function updateCartMystery(keyId, qty){
    var formData = new FormData();
    formData.append('id', keyId);
    formData.append('quantity', qty);
  
    fetch('/cart/change.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      return response.json();
       
    })
    .then(data => {
      console.log('Success:', data);
      console.log('data.item_count:', data.item_count);
      document.querySelector(".cart-number.text-center.abs-number").innerHTML= data.item_count;
      document.querySelector(".cart-number.abs-number.cart-number--header").innerHTML= data.item_count;
      
       setTimeout(refreshCartMystery, 200);
       showAlertMystery()

       updateCartObject();


    })
    .catch((error) => {
      console.error('Error:', error);
    }); 
     
    //fetchCartAgain();
  
}
  
function refreshCartMystery(){
    var url =  "/?view=header_cart";
    var xhttp= createCORSRequest('GET', url);
  
  
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        var header__cart_drawer = document.getElementById("header__cart_drawer");
        
        if (header__cart_drawer != null){
          header__cart_drawer.innerHTML = xhttp.responseText;
          console.log("header__cart_drawer",header__cart_drawer);
        }
     
      }
    };
    xhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhttp.send(); 
}
  
function showAlertMystery(){
    
    var notifyAlert = document.getElementsByClassName("alert")[0];
    notifyAlert.innerText = "You can only add 5 max quantity of Mystery Grab Bags on each purchase."
    removeClass(notifyAlert,"alert-success");
    addClass(notifyAlert,"alert-danger");
        
    notifyAlert.style.display = "block";
    //document.getElementsByClassName('button--single-cart-main')[0].style.cursor = "not-allowed";
    setTimeout(hideAlertMystery, 5000);
}
    
function hideAlertMystery(){
    var notifyAlert = document.getElementsByClassName("alert")[0];
    notifyAlert.innerText = ""
    removeClass(notifyAlert,"alert-danger");
    addClass(notifyAlert,"alert-success");
        
    notifyAlert.style.display = "none";
    
} 